import { tv, type VariantProps } from "tailwind-variants";

export const heroVariant = tv({
  slots: {
    base: ["w-full", "py-4"],
    wrapper: ["container-fluid"],
    hero: [
      "relative",
      "flex",
      "w-full",
      "h-[calc(100dvh-120px)]",
      "min-h-[516px]",
      "max-h-[526px]",
      "rounded-2xl",
      "overflow-hidden",
      "desktop:max-h-none",
      "desktop:min-h-[652px]",
      "2xl:max-h-[960px]",
    ],
    content: [
      "relative",
      "z-12",
      "flex",
      "flex-col",
      "flex-shrink-0",
      "justify-between",
      "items-start",
      "gap-y-10",
      "w-full",
      "p-7",
      "sm:w-[85%]",
      "md:w-[75%]",
      "desktop:w-full",
    ],
    title: [
      "xl:pr-7.25",
      "text-brand-pure-white",
      "max-w-[1200px]",
      "lg:-translate-y-4.25",
    ],
    description: [
      "w-full",
      "max-w-[650px]",
      "text-text-static-white-soft",
      "-translate-y-4.25",
    ],
    media: ["w-full", "h-full", "object-cover", "rounded-2xl", "overflow-hidden"],
    figure: [
      "md:absolute",
      "z-0 top-0 left-0",
      "w-full md:h-full",
      "aspect-w-1 aspect-h-1 md:aspect-none",
    ],
    image: ["object-cover"],
    videoWrapper: [
      "absolute",
      "z-10",
      "inset-0",
      "block",
      "w-full",
      "h-full",
      "bg-black",
    ],
    videoContainer: ["h-full", "w-full"],
    video: ["w-full", "h-full", "object-cover", "bg-black"],
    button: ["mt-auto"],
  },
  variants: {},
  defaultVariants: {},
});

export type HeroVariantProps = VariantProps<typeof heroVariant>;
export type HeroReturnVariantProps = ReturnType<typeof heroVariant>;
